import React, { useEffect } from 'react'
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom'

import AuthService from '../../utilities/services/auth.service'

import { MarketplaceSubnav } from '../../components/MarketplaceWrapper'

export default function MarketplacePage() {
  const organization = AuthService.getOrg()?.[0]
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    if (location.pathname === '/settings/marketplace') {
      navigate('items', { replace: true })
    }
  }, [location.pathname, navigate])

  if (!organization?.setting?.foodAndBeverage) {
    return <Navigate to="/settings/organization-information" replace />
  }

  return (
    <>
      <header className="section-header">
        <div className="section-heading section-heading--secondary">
          <h1>Marketplace</h1>
        </div>
        <p className="section-header-desc">
          Set up food &amp; beverage items, categories, and where they can be
          sold
        </p>
      </header>
      <MarketplaceSubnav />
      <Outlet />
    </>
  )
}
